import { initializeApp } from "firebase/app";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDg_Pq4pvNyMhcR34lDcHTA60Daw2N2jeo",
    authDomain: "hodaya-website-2f1d7.firebaseapp.com",
    projectId: "hodaya-website-2f1d7",
    storageBucket: "hodaya-website-2f1d7.appspot.com",
    messagingSenderId: "955483509217",
    appId: "1:955483509217:web:2725647617e3de3fccc2a0",
    measurementId: "G-J2JJRR85BB"
};

// Initialize Firebase
initializeApp(firebaseConfig);